import React from 'react';

import Header from './Header';

const DisciplineBreakdown = () => {
    return (
        <div className={'ohs-breakdown'}>
            <Header/>

            <div className={'ohs-breakdown__content ohs-content-padding'}>
                <h2 className={'ohs-breakdown__heading'}>
                    Breaking Down the Four Disciplines of a Healthy Organization
                </h2>

                <p className={'ohs-breakdown__intro'}>
                    The first step toward creating a healthy organization is to embrace the idea that, like so many
                    other aspects of success, organizational health is simple in theory but difficult to put into
                    practice. It requires extraordinary levels of courage, commitment, and consistency. However, it does
                    not require complex thinking and analysis; in fact, keeping things simple is critical. The second
                    step is to master these fundamental disciplines and put them into practice on a daily basis. What
                    follows is a summary to help you understand how to do just that.
                </p>

                <div className={'ohs-breakdown__discipline'}>
                    <h3 className={'ohs-breakdown__discipline-title'}>Discipline 1: Build a Cohesive Leadership
                        Team</h3>
                    <p className={'ohs-breakdown__discipline-intro'}>
                        At the heart of every healthy organization is a leadership team that eliminates politics and
                        creates the foundation for clarity and alignment by:
                    </p>
                    <ul className={'ohs-breakdown__list'}>
                        <li>Knowing one another's unique strengths and weaknesses</li>
                        <li>Openly engaging in constructive ideological conflict</li>
                        <li>Committing to group decisions</li>
                        <li>Holding one another accountable for behaviors and actions</li>
                        <li>Focusing relentlessly on collective results</li>
                    </ul>
                </div>

                <div className={'ohs-breakdown__discipline'}>
                    <h3 className={'ohs-breakdown__discipline-title'}>Discipline 2: Create Clarity</h3>
                    <p className={'ohs-breakdown__discipline-intro'}>
                        Healthy organizations minimize the potential for confusion by clarifying:
                    </p>
                    <div className={'ohs-breakdown__two-col'}>
                        <ul className={'ohs-breakdown__list'}>
                            <li>Why do we exist?</li>
                            <li>What do we do?</li>
                            <li>What is most important &mdash; right now?</li>
                        </ul>
                        <ul className={'ohs-breakdown__list'}>
                            <li>How do we behave?</li>
                            <li>How will we succeed?</li>
                            <li>Who must do what?</li>
                        </ul>
                    </div>
                </div>

                <div className={'ohs-breakdown__discipline'}>
                    <h3 className={'ohs-breakdown__discipline-title'}>Discipline 3: Over-Communicate Clarity</h3>
                    <p className={'ohs-breakdown__discipline-intro'}>
                        Healthy organizations align their employees around organizational clarity by communicating
                        key messages through:
                    </p>
                    <ul className={'ohs-breakdown__list'}>
                        <li>Repetition: Don't be afraid to repeat the same message, again and again</li>
                        <li>Simplicity: The more complicated the message, the more potential for confusion
                            and inconsistency
                        </li>
                        <li>Multiple mediums: People react to information in many ways; use a variety of mediums</li>
                        <li>Cascading messages: Leaders communicate key messages to direct reports; the cycle
                            repeats itself until the message is heard by all
                        </li>
                    </ul>
                </div>

                <div className={'ohs-breakdown__discipline'}>
                    <h3 className={'ohs-breakdown__discipline-title'}>Discipline 4: Reinforce Clarity</h3>
                    <p className={'ohs-breakdown__discipline-intro'}>
                        Organizations sustain their health by ensuring consistency in:
                    </p>
                    <div className={'ohs-breakdown__two-col'}>
                        <ul className={'ohs-breakdown__list'}>
                            <li>Hiring</li>
                            <li>Meeting structure</li>
                            <li>Employee dismissal</li>
                        </ul>
                        <ul className={'ohs-breakdown__list'}>
                            <li>Managing performance</li>
                            <li>Rewards and recognition</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DisciplineBreakdown;
